import { render, staticRenderFns } from "./tag_list.vue?vue&type=template&id=41f51b68&"
import script from "./tag_list.vue?vue&type=script&lang=js&"
export * from "./tag_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports